<template>
  <page>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-autocomplete :label="labels.busCls" :items="busClsList" v-model="filters.busCls" item-text="value" item-value="code" data-vv-name="busCls" :data-vv-as="labels.busCls" :error-messages="errors.collect('busCls')"></v-autocomplete>
                      </v-flex>
                      <v-flex md6>
                        <v-autocomplete :label="labels.benefit" :items="benefitList" v-model="filters.benefit" item-text="value" item-value="code" data-vv-name="benefit" :data-vv-as="labels.benefit" :error-messages="errors.collect('benefit')"></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="doNew()">
              New Permitted Benefit
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
            <download-csv :data="pmtBenefitPerBusCls" name="PermittedBenefitList.csv">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="mx-2" fab dark small color="primary" v-on="on">
                    <v-icon dark>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Download CSV</span>
              </v-tooltip>
            </download-csv>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.busCls }}</td>
                <td>{{ row.item.benefit }}</td>
                <td>{{ row.item.defBen ? 'Yes' : 'No' }}</td>
                <td>{{ row.item.benLongDesc }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)" query @query="doQuery(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Permitted Benefit?
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Business Class', value: 'busCls' },
        { text: 'Benefit', value: 'benefit' },
        { text: 'Default Benefit', value: 'defBen' },
        { text: 'Benefit Long Description', value: 'benLongDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        busCls: 'Business Class',
        benefit: 'Benefit',
        defBen: 'Default Benefit',
        benLongDesc: 'Benefit Long Description'
      },
      filters: {
        busCls: undefined,
        benefit: undefined,
        defBen: undefined,
        benLongDesc: undefined
      },
      totalItems: 0,
      selectedProp: undefined,
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      busClsList: [],
      benefitList: [],
      pmtBenefitPerBusCls: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInit(options) {
      await this.getAll()
      this.resetMessages()
      const apiURI = this.menu.getPmtBenefitPerBusClsList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  busCls: datamap.busCls,
                  benefit: datamap.benefit,
                  defBen: datamap.defBen,
                  benLongDesc: datamap.benLongDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async getAll() {
      const apiURI = this.menu.getAllPmtBenefitPerBusClsList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.pmtBenefitPerBusCls = []
        if (data) {
          data.map((datamap) => {
            const convertList = {
              busCls: datamap.busCls,
              benefit: datamap.benefit,
              defBen: datamap.defBen,
              benLongDesc: datamap.benLongDesc
            }
            this.pmtBenefitPerBusCls.push(convertList)
          })
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.busCls = undefined
      this.filters.benefit = undefined
      this.filters.defBen = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      this.$router.push({ name: 'pmtBenefitPerBusClsReview', params: { pmtBenefitMode: 'review', pmtBenefitObjRes: obj } })
    },
    doNew() {
      this.$router.push({ name: 'pmtBenefitPerBusClsReview', params: { pmtBenefitMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'pmtBenefitPerBusClsReview', params: { pmtBenefitMode: 'query', pmtBenefitObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.deletePmtBenefitPerBusCls
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doFetchBusClsList() {
      const apiURI = this.menu.getBusClsHelpList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.busClsList = []
            const { data } = result.data
            if (data) {
              data.map((busClsMap) => {
                const convertList = {
                  code: busClsMap.busCls,
                  value: busClsMap.busCls + ' - ' + busClsMap.busClsDesc
                }
                this.busClsList.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchBenefitList() {
      const apiURI = this.menu.getBenefitHelpList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.benefitList = []
            const { data } = result.data
            if (data) {
              data.map((benefitMap) => {
                const convertList = {
                  code: benefitMap.benefit,
                  value: benefitMap.benefit + ' - ' + benefitMap.benefitShortDesc
                }
                this.benefitList.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.pmtBenefitPerBusCls.menu
    }
  },
  mounted() {
    this.doFetchBusClsList()
    this.doFetchBenefitList()
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
